import { render } from "./RemovableTag.vue?vue&type=template&id=256fd910"
import script from "./RemovableTag.vue?vue&type=script&lang=ts"
export * from "./RemovableTag.vue?vue&type=script&lang=ts"
script.render = render

export default script